import { STATS } from "../../data/content";
import AnimatedCounter from "../shared/AnimatedCounter";
import useReveal from "../shared/useReveal";
import "./StatsBand.css";

export default function StatsBand() {
  const ref = useReveal();

  return (
    <section className="home-stats-band">
      <div className="container home-stats-grid" ref={ref}>
        {STATS.map((stat) => (
          <div className="home-stat pm-reveal" key={stat.label}>
            <b>
              <AnimatedCounter
                value={stat.value}
                prefix={stat.prefix || ""}
                suffix=""
              />
              <i className="gold-sfx">{stat.suffix || ""}</i>
            </b>
            <span>{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
